import React from "react";
import { FormattedMessage } from "react-intl";

export const translateByMessageIdParam = (msgId,param ='') => { 
  return <FormattedMessage id={msgId} values={{ msgParam: `${param}` }}/> ;
  } 